import axios from 'axios'
import requestErrorServices from '../services/requestErrorServices'

export default class {
  // Charge la liste des newsletters en fonction du camping
  static loadFaq (campingId) {
    return new Promise((resolve, reject) => {
      axios.get('/api/faq/get/' + campingId, null)
        .then(function (response) {
          var model = response.data
          resolve(model)
        })
        .catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // Sauvegarde les items d'une categorie pour un camping
  static saveFaqCategory (campingId, model) {
    return new Promise((resolve, reject) => {
      axios.put('/api/faq/updateCategoryItems/' + campingId, model)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static saveChildrenAmenities (campingId, model) {
    return new Promise((resolve, reject) => {
      axios.put('/api/faq/updateChildrenAmenities/' + campingId, model)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static saveFaqAnimals (campingId, model) {
    return new Promise((resolve, reject) => {
      axios.put('/api/faq/updateAnimals/' + campingId, model)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static saveFaqPools (campingId, model) {
    return new Promise((resolve, reject) => {
      axios.put('/api/faq/updatePools/' + campingId, model)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static saveFaqReception (campingId, model) {
    return new Promise((resolve, reject) => {
      axios.put('/api/faq/updateReception/' + campingId, model)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }
}
